// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { LinkFragmentDoc } from '../../../../cms/index.generated';
export const PreHeaderFragmentDoc = gql`
    fragment preHeader on PreHeader {
  __typename
  link {
    ...link
  }
}
    ${LinkFragmentDoc}`;